export const APP_ROUTES = {
  MY_BOOKING_PAGE: 'bookings/:key',
  ERROR_PAGE: 'error'
};
